import React from 'react'
import GitHubIcon from '@mui/icons-material/GitHub';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import InstagramIcon from '@mui/icons-material/Instagram';

const AsideL = () => {
  return (
    <div className='flex-col  h-screen  hidden  md:flex'>
    <div className=' flex-col flex h-screen  justify-center items-center  text-gray-400  '>
      <div className='motion-safe:hover:scale-110 hover:text-emerald-400'>
        <a target='_blank' href='https://github.com/Yeremi528'> <GitHubIcon/>  </a>
      </div>
      <div className='mt-6 motion-safe:hover:scale-110 hover:text-emerald-400'>
        <a target='_blank' href='https://www.linkedin.com/in/yeremi-araya-urbina/'><LinkedInIcon/></a>
        
      </div>
      <div className='mt-6 motion-safe:hover:scale-110 hover:text-emerald-400 '>
        <a target='_blank' href='https://www.instagram.com/alej4ndro0o/?hl=es-la'> <InstagramIcon/>  </a>
      </div>
      
    </div>
  </div>
   
  )
}

export default AsideL